@if (commentsData && commentsData.length) {
  <p-dataView [value]="commentsData"
              layout="list"
              styleClass="mb-4"
              [paginator]="false">
    <ng-template #list
                 let-commentDataItems>
      @for (commentData of commentDataItems; track commentData) {
        <div class="col-12 mt-3 pb-3">
          <sc-comment [commentData]="commentData"
                      (update)="onCommentUpdate()"
                      (delete)="onCommentDelete()"></sc-comment>
        </div>
      }
    </ng-template>
  </p-dataView>
}

<form class="mt-3"
      [formGroup]="form"
      (ngSubmit)="addComment()">

  <div class="flex flex-column">
    <div class="field">
      <textarea inputId="textarea"
                pTextarea
                pAutoResize
                placeholder="Write your comments..."
                [rows]="3"
                formControlName="description"
                i18n-placeholder
                class="w-full"></textarea>
      @if (submitted && form.controls.description.invalid) {
        <small class="p-error">{{ descriptionError }}</small>
      }
    </div>
    <p-button scSubmitButton
              [requestInProcess]="requestInProcess"
              class="align-self-center mt-6"
              label="Add comment"
              i18n-label></p-button>
  </div>
</form>